// Simple and reliable variant metafield display with clickable link
(function () {
  "use strict";

  // Debug mode
  const DEBUG = true;
  const PRO_PRICING_URL = "https://nova-wax.com/pages/pro-pricing-signup-form";

  // Log helper
  function log(...args) {
    if (DEBUG) console.log("[Variant Metafield]", ...args);
  }

  // Log that script is loaded
  log("Script loaded and running");

  // Function to create and show the metafield
  function createAndShowMetafield() {
    // Find all metafield elements
    const metafieldElements = document.querySelectorAll(".variant-metafield-display");
    
    metafieldElements.forEach(metafieldElement => {
      // Skip if already processed
      if (metafieldElement.tagName === 'A' || metafieldElement.closest('a')) {
        return;
      }
      
      const metafieldText = metafieldElement.textContent.trim();
      if (!metafieldText) {
        log("No metafield text found");
        return;
      }

      // Create a clickable link element
      const link = document.createElement("a");
      link.href = PRO_PRICING_URL;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.className = metafieldElement.className;
      
      // Copy all attributes
      Array.from(metafieldElement.attributes).forEach(attr => {
        if (attr.name !== 'class') {
          link.setAttribute(attr.name, attr.value);
        }
      });
      
      // Move all child nodes to the new link
      while (metafieldElement.firstChild) {
        link.appendChild(metafieldElement.firstChild);
      }
      
      // Replace the original element with the new link
      metafieldElement.parentNode.replaceChild(link, metafieldElement);
      
      log("Metafield converted to clickable link");
    });
  }

  // Add global styles if not already added
  if (!document.getElementById("variant-metafield-styles")) {
    const style = document.createElement("style");
    style.id = "variant-metafield-styles";
    style.textContent = `
      .variant-metafield-display {
        display: inline-flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        margin-left: 15px !important;
        padding: 5px 10px !important;
     
        font-size: 16px !important;
        font-weight: 600 !important;
        color: #333 !important;
        text-decoration: none !important;
        vertical-align: middle !important;
        position: relative !important;
        z-index: 9999 !important;
        transition: all 0.2s ease !important;
        cursor: pointer !important;
      }
      
      .variant-metafield-display:hover {
       color: #7D70B3 !important;
        text-decoration: none !important;
        transform: translateY(-1px) !important;
     
      }
      
      @media (max-width: 480px) {
        .variant-metafield-display {
          font-size: 14px !important;
          padding: 4px 8px !important;
          margin-left: 10px !important;
        }
      }`;
    document.head.appendChild(style);
  }

  // Run on page load
  document.addEventListener("DOMContentLoaded", createAndShowMetafield);

  // Also run after a short delay to catch any dynamic content
  setTimeout(createAndShowMetafield, 1000);

  // Run on any AJAX updates
  document.addEventListener("click", createAndShowMetafield);
  document.addEventListener("change", createAndShowMetafield);

  // Set up a mutation observer to ensure it stays visible
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const metafield = document.querySelector(
        ".variant-metafield-display, #variant-metafield-display"
      );
      if (metafield) {
        if (
          metafield.style.display === "none" ||
          metafield.style.visibility === "hidden" ||
          metafield.style.opacity === "0"
        ) {
          metafield.style.display = "inline-flex";
          metafield.style.visibility = "visible";
          metafield.style.opacity = "1";
        }
      } else {
        // If metafield was removed, recreate it
        createAndShowMetafield();
      }
    });
  });

  // Start observing the document
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["style", "class"],
  });

  // Also run periodically as a fallback
  setInterval(createAndShowMetafield, 1000);

  log("Initialization complete");
})();
